var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTax = function SvgTax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 5.5C7.87564 5.5 9.6665 4.60457 9.6665 3.5C9.6665 2.39543 7.87564 1.5 5.6665 1.5C3.45736 1.5 1.6665 2.39543 1.6665 3.5C1.6665 4.60457 3.45736 5.5 5.6665 5.5Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 6.16667V3.5",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 3.5V13.5C1.6665 14.6067 3.45984 15.5 5.6665 15.5C6.04352 15.5013 6.42012 15.4746 6.79317 15.42",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 11C1.6665 12.1067 3.45984 13 5.6665 13C6.05254 12.999 6.43799 12.97 6.81984 12.9133",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 8.5C1.6665 9.60667 3.45984 10.5 5.6665 10.5C6.04352 10.5013 6.42012 10.4746 6.79317 10.42",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 6C1.6665 7.10667 3.45984 8 5.6665 8C6.05254 7.99898 6.43799 7.97001 6.81984 7.91333",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 11.666C14.8756 11.666 16.6665 10.7706 16.6665 9.66602C16.6665 8.56145 14.8756 7.66602 12.6665 7.66602C10.4574 7.66602 8.6665 8.56145 8.6665 9.66602C8.6665 10.7706 10.4574 11.666 12.6665 11.666Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 9.66602V14.4993C8.6665 15.606 10.4598 16.4993 12.6665 16.4993C14.8732 16.4993 16.6665 15.606 16.6665 14.4993V9.66602",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 12C16.6665 13.1067 14.8732 14 12.6665 14C10.4598 14 8.6665 13.1067 8.6665 12",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTax;